import { useStateValue } from '../../context/StateValueContext';
import { PERMISSIONS } from '../../constants/permissions';
import VerifiNoticesAdmin from './VerifiNoticesAdmin';
import ClientFraudNotices from '../ClientAlerts/ClientFraudNotices';

export default function FraudSwitcher() {
  const [{ user }] = useStateValue();

  if (user?.permissions?.includes(PERMISSIONS.ALERTS_ALL)) {
    return <VerifiNoticesAdmin caseType="FRAUD_NOTICE" title="Fraud Notices (TC40)" />;
  }

  return <ClientFraudNotices />;
}
